import { Component, OnInit, Input } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { FormGroup, FormControl } from '@angular/forms';
import { ProfileService } from '../../services/profile.service';
import * as firebase from 'firebase/app';
import 'firebase/auth';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.page.html',
  styleUrls: ['./modal.page.scss'],
})
export class ModalPage implements OnInit {
  @Input() name: string;
  @Input() fields: any;

  formFieldGroup: any;
  profileForm = new FormGroup({});
  formList: any;
  uid: any;
  email: string;

  constructor(navParams: NavParams, private modalCtrl: ModalController, private profileService: ProfileService) {
    // console.log('to modal', navParams.get('fields'));
    // this.formList = navParams.get('fields');
    this.formList = localStorage.getItem('fields');

    const group = {};
    let fieldList = [];
    this.formList.forEach(field => {
      console.log('fields in modal', field.name);
      // fieldList.push({
      //   name: this.formList.value.name,
      //   value: this.formList.value.value
      // });
      // group[field.name] = new FormControl('');
    });
    
    console.log('form fields', this.formList);
    this.profileForm = new FormGroup(group);
    console.log('form input', this.profileForm);
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.uid = user.uid;
        this.email = user.email;
      }
    });

  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

  ngOnInit() {
  }

  onFormSubmit(): void {
    // let fields = [];
    // console.log(this.profileForm.value);
    // this.formList.forEach(item => {
    //   // console.log('item', item.title, item.value);
    //   // fields.push({
    //   //   item.title: item.value,
    //   //   value: item.value
    //   // });
      
    // });
    this.profileService.setProfile(this.uid, this.profileForm.value);
    // this.formResult.emit(this.userForm.value);
    this.profileForm.reset();
  }

}
